/**
 * Kommentare neueste zuerst.
 *
 * Jira liefert Zeitstempel mit Zonen-Offset (`2026-09-22T14:20:00.000+0200`),
 * ein optimistisch eingefügter Kommentar dagegen mit `Z`. Als Zeichenkette
 * verglichen (`localeCompare`) steht `+0200` lexikografisch VOR `Z`, egal
 * welcher Zeitpunkt gemeint ist — die Sortierung vertauscht dann echte und
 * optimistische Einträge. `Date.parse` vergleicht den tatsächlichen
 * Zeitpunkt statt der Schreibweise. Ein nicht parsbarer Zeitstempel zählt als
 * `0` (Unix-Epoch) statt `NaN` in die Sortierung zu tragen, wo jeder
 * Vergleich `false` ergäbe und die Reihenfolge undefiniert bliebe.
 */
export function sortNewestFirst<T extends { createdIso: string }>(comments: T[]): T[] {
  return comments.slice().sort((a, b) => parseIso(b.createdIso) - parseIso(a.createdIso));
}

function parseIso(iso: string): number {
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? 0 : ms;
}
